import api, { auth } from './api';

export const CSRF_KEY = 'csrf';

export const getCsrf = () => localStorage.getItem(CSRF_KEY);

export const setCsrf = csrf => {
  localStorage.setItem(CSRF_KEY, csrf);
};

export const create = data => {
  return api.post('/auth/signup', data).then(response => {
    return response;
  });
};

export const logout = () => {
  return api.get('auth/logout');
};

export const requestCsrf = () => {
  return auth.get('csrf-token');
};

export const subscriber = (email, uid, isFromLoop = false) => {
  return api.post(`subscribe/channel/${uid}`, { email, isFromLoop });
};

export const requestAuthValidation = (hash, code) => {
  return api.post('auth/signin/email', { hash, code });
};

export const requestAuthValidationFromEmail = key => {
  return api.post('auth/signin/email', { key });
};

export const checkCookie = key => {
  return api.post('auth/request_cookie_auth', { key: key });
};

export const checkIfAuthenticationIsValid = key => {
  return api.get('auth/check_auth');
};

export const requestUserData = () => {
  return api.get('auth/me');
};

export const checkIfIsAdmin = key => {
  return api.get('admin/check_user');
};
